import React from "react";
import { Container } from "./PI";

function HealthDataConsentPage() {
  return (
    <Container>
      <h1 className='title'>건강 데이터 민감정보 수집·이용 동의</h1>
      <br />
      <p>시행일: 2026년 6월 29일</p>
      <br />
      <p>
        {`본 동의는 GH코인 운동 추가 보상을 계산하기 위해 필요한 선택 동의입니다.

회원은 본 동의를 거부할 수 있습니다. 다만 동의하지 않으면 건강 데이터를 이용한 운동 추가 보상은 계산되지 않으며, 운동 추가 보상이 지급되지 않을 수 있습니다. 운동 기본 보상, 체크인 보상, 수업 출석 보상은 각 보상 조건을 충족한 경우 별도로 지급됩니다.`}
      </p>
      <br />
      <br />

      <h4>1. 수집·이용 목적</h4>
      <br />
      <p>
        {`회사는 회원의 운동 추가 보상을 계산하고 안내하기 위해 건강 데이터를 이용합니다.

구체적으로, 회원의 운동 세션 중 심박 기록을 기준으로 GH코인 운동 추가 보상을 계산하고, 계산된 보상 금액과 심박 구간 시간, 보상 수령 가능 여부를 앱에서 안내합니다.

또한 보상 미지급, 중복 지급, 비정상 지급 등과 관련한 오류 확인 및 회원 문의 대응을 위해 건강 데이터 요약 정보를 이용할 수 있습니다. 심박 기록 조회 여부와 계산 결과를 확인하여 비정상적인 적립을 방지하는 데에도 사용됩니다.

회사는 위 목적 외의 광고, 마케팅, 보험 심사, 신용평가 목적으로 건강 데이터를 이용하지 않습니다.`}
      </p>
      <br />
      <br />

      <h4>2. 수집·이용 항목</h4>
      <br />
      <p>
        {`회사는 회원의 휴대폰에 연동된 외부 건강 앱에서 운동 추가 보상 계산에 필요한 정보를 조회합니다.

외부 건강 앱은 iOS의 건강 앱과 Android의 삼성 헬스를 의미합니다. 회사는 운동 세션 시간대의 심박 기록, 건강 데이터 접근 권한 상태, 건강 데이터 확인 가능 여부를 조회합니다.

회사 시스템에는 운동 추가 보상 계산에 필요한 요약 정보만 저장됩니다. 저장되는 정보는 심박 60% 이상 70% 미만 구간 시간, 심박 70% 이상 구간 시간, 평균 심박수, 심박 기록 조회 여부, 계산된 GH코인 수, 보상 수령 상태, 계산 기준 버전입니다.

운동 추가 보상 지급 및 기록 관리를 위해 회원, 센터, 운동 세션을 식별하기 위한 정보도 함께 처리됩니다.

회사는 외부 건강 앱에 기록된 개별 심박 측정값을 원본 그대로 저장하지 않습니다. 평균 심박수는 개별 심박 측정값이 아니라 운동 추가 보상 계산 결과에 포함되는 요약 정보로 저장됩니다. GPS 경로, 위치 좌표, 이동 경로도 저장하지 않습니다. 외부 건강 앱의 원본 운동 기록 ID나 운동 기록 목록도 저장하지 않으며, 걸음 수 원본 기록이나 운동 앱의 상세 원본 데이터도 저장하지 않습니다.`}
      </p>
      <br />
      <br />

      <h4>3. 운동 추가 보상 계산 방식</h4>
      <br />
      <p>
        {`오늘의습관 앱은 운동 중 심박을 직접 측정하지 않습니다. 회원이 오늘의습관 앱에서 운동을 시작한 뒤, 외부 건강 앱에 기록된 심박 데이터를 조회하여 운동 추가 보상을 계산합니다.

운동 추가 보상은 최대 심박수를 기준으로 계산합니다. 최대 심박수는 220에서 회원의 만 나이를 뺀 값입니다.

운동 세션 중 심박이 최대 심박수의 60% 미만인 시간은 운동 추가 보상으로 인정되지 않습니다. 최대 심박수의 60% 이상 70% 미만인 시간은 1분당 5코인으로 계산합니다. 최대 심박수의 70% 이상인 시간은 1분당 10코인으로 계산합니다.

1회 운동 세션에서 적립되는 보상의 합계(헬스 체크인 보상, 운동 기본 보상, 운동 추가 보상의 합)는 500코인을 넘지 않습니다. 위 기준으로 계산한 운동 추가 보상을 더한 합계가 500코인을 초과하는 경우, 운동 추가 보상은 해당 세션의 적립 합계가 500코인이 되도록 조정되어 지급됩니다.

수업 출석 보상은 본 상한에 포함되지 않고 별도로 지급됩니다. 수업 출석 보상이 지급되는 경우에도 해당 운동 세션의 운동 추가 보상은 위 상한과 동일하게 최대 500코인까지 계산됩니다.

운동 세션은 운동 종류에 따라 정해진 타이머로 진행됩니다. 센터 밖 운동은 30분, 센터 운동과 수업 운동은 60분 타이머로 진행되며, 타이머가 00:00에 도달하면 운동 세션이 자동으로 종료됩니다.

운동 추가 보상은 오늘의습관 앱에서 운동 세션을 시작한 시각부터 운동 세션이 종료된 시각까지 확인된 심박 기록으로 계산됩니다.

심박 기록이 전혀 확인되지 않거나 외부 건강 앱의 심박 기록이 아직 동기화되지 않은 경우, 운동 추가 보상이 0코인으로 표시되거나 다시 조회가 필요할 수 있습니다. 심박 기록이 1분 이상 확인되면, 확인된 심박 기록만 기준으로 운동 추가 보상을 계산합니다.`}
      </p>
      <br />
      <br />

      <h4>4. 보유 및 이용 기간</h4>
      <br />
      <p>
        {`회사는 운동 추가 보상 계산에 사용된 건강 데이터 요약 정보를 GH코인 수령 완료일 또는 수령 가능 기간 만료일로부터 90일 동안 보관한 뒤 파기합니다.

GH코인 적립·사용 기록은 관련 법령 및 회사의 GH코인 기록 보관 기준에 따라 보관됩니다.

회사는 원본 심박 기록, GPS 경로, 위치 좌표, 외부 건강 앱의 원본 운동 기록은 저장하지 않습니다.`}
      </p>
      <br />
      <br />

      <h4>5. 동의 거부 시 영향</h4>
      <br />
      <p>
        {`회원은 본 동의를 거부할 수 있습니다.

본 동의를 거부하거나 철회한 경우에도 앱 이용과 운동 세션 기록은 가능합니다. 다만 건강 데이터를 이용한 운동 추가 보상은 계산할 수 없으며, 운동 추가 보상이 지급되지 않습니다.

운동 기본 보상, 체크인 보상, 수업 출석 보상은 건강 데이터 동의 여부와 관계없이 각 보상 조건을 충족한 경우 지급됩니다.

운동 추가 보상을 받으려면 오늘의습관 앱에서 본 동의가 완료되어 있어야 합니다. 또한 iOS 건강 앱 또는 Android 삼성 헬스 접근 권한이 허용되어 있어야 하고, 외부 건강 앱에 운동 시간대의 심박 기록이 확인되어야 합니다.

운동 추가 보상은 운동 종료 후 24시간 이내에 받을 수 있습니다. 운동 추가 보상 수령이 완료되었거나 수령 가능 시간이 지난 뒤에는, 이후 동의하거나 건강 데이터가 동기화되더라도 해당 운동 세션의 운동 추가 보상은 다시 계산되지 않습니다.`}
      </p>
      <br />
      <br />

      <h4>6. 동의 철회</h4>
      <br />
      <p>
        {`회원은 앱의 권한 또는 동의 관리 화면에서 본 동의를 철회할 수 있습니다.

동의를 철회하면 철회 이후의 운동 세션에 대해서는 건강 데이터를 이용한 운동 추가 보상이 계산되지 않습니다.

동의 철회 전에 이미 지급된 GH코인 적립 기록은 GH코인 기록 보관 기준에 따라 관리됩니다. 운동 추가 보상 계산에 사용된 건강 데이터 요약 정보는 보유 기간이 지나면 파기됩니다.`}
      </p>
      <br />
      <br />

      <h4>7. 제3자 제공</h4>
      <br />
      <p>
        {`회사는 본 동의에 따라 처리하는 건강 데이터 요약 정보를 제3자에게 제공하지 않습니다.

향후 제3자 제공이 필요한 경우, 제공받는 자, 제공 목적, 제공 항목, 보유 기간을 별도로 안내하고 필요한 동의를 받습니다.`}
      </p>
      <br />
      <br />

      <h4>8. 동의 문구</h4>
      <br />
      <p>
        {`회원은 아래 문구에 동의함으로써 건강 데이터 민감정보 수집·이용에 동의합니다.

[선택] GH코인 운동 추가 보상 계산을 위한 건강 데이터 민감정보 수집·이용에 동의합니다.`}
      </p>
      <br />
      <br />
    </Container>
  );
}

export default HealthDataConsentPage;
